import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import { useLanguage } from '../../hooks/useLanguage';
import { fetchProducts } from '../../services/productApi';
import { getTranslatedProduct } from '../../utils/translationUtils';
import { useCurrency } from '../../context/CurrencyContext';

const MostSellingPaintProduct = () => {
  const { t, i18n } = useTranslation();
  const { getLocalizedPath } = useLanguage();
  const { formatPrice } = useCurrency();
  const [items, setItems] = useState([]);
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  console.log(loading, error);
  useEffect(() => {
    (async () => {
      setLoading(true);
      setError('');
      try {
        const params = new URLSearchParams({
          page: '1',
          limit: '12',
          category: 'paints',
        });
        const res = await fetchProducts(params);
        setItems(res.data || []);
      } catch (e) {
        setError(e.message || 'Failed to load products');
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <section className="w-full px-4 sm:px-6 xl:px-8 pt-20 pb-20 sm:pt-28 sm:pb-[90px] mb-20 md:mb-[120px]">
      <div className="max-w-[1350px] w-full mx-auto">
        <h2 className="text-center libre-baskerville font-normal text-[32px] md:text-[56px] leading-[40px] md:leading-[81px] text-[#1D1D1F]">
          Most Selling Paint Products
        </h2>
        <div className="mt-10 justify-items-center grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-4 sm:gap-8 lg:gap-x-[50px] lg:gap-y-10">
          {items.map((p) => (
            <div
              key={p.id}
              className="bg-white rounded-[15px] mx-auto max-w-[287px] w-full hover:shadow-md transition-all duration-300"
            >
              <Link
                to={getLocalizedPath(`/product/${encodeURIComponent(p.id)}`)}
                className="block"
              >
                <div className="rounded-[15px] bg-[#EDEDED] overflow-hidden h-[360px] flex items-center justify-center">
                  <img
                    src={
                      (p.images && p.images[0]) ||
                      '/assets/paint-product-1.webp'
                    }
                    alt={p.name}
                    className="w-full h-full object-contain"
                  />
                </div>
              </Link>
              <div className="pt-6 text-center pb-4">
                <p className="text-[#A0A0A0] text-[12px] leading-[24px] font-medium">
                  Limited Edition
                </p>
                <h3 className="text-[#1D1D1F] text-[16px] leading-[24px] font-medium mt-[9px]">
                  {getTranslatedProduct(p, 'name', i18n.language)}
                </h3>
                <p className="text-[#1D1D1F] text-[16px] leading-[22px] font-medium">
                  {formatPrice(p.price ?? 0)}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default MostSellingPaintProduct;
